import type { NodeStatus } from '../../generated/nodeDataTypes'

const EDGE_ACTIVE_NODE_STATUS_VALUES: readonly NodeStatus[] = [
  'running',
  'pending_execution',
  'pending_cost_confirmation',
]

const EDGE_ACTIVE_NODE_STATUSES: ReadonlySet<string> = new Set(EDGE_ACTIVE_NODE_STATUS_VALUES)
const EDGE_RUNNING_NODE_STATUS: NodeStatus = 'running'

export function isEdgeActiveNodeStatus(status: string | undefined): status is NodeStatus {
  return typeof status === 'string' && EDGE_ACTIVE_NODE_STATUSES.has(status)
}

export function isEdgeRunningNodeStatus(status: string | undefined): status is NodeStatus {
  return status === EDGE_RUNNING_NODE_STATUS
}
